import styled from 'styled-components';

export const Container = styled.div`
  margin: 1rem;
  & > span {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  & > .error-container {
    width: 17rem;
    display: flex;
    flex-direction: column;
    margin: 0 15rem 0 auto;
    text-align: center;

    & > span {
      font-size: 0.75rem;
      color: ${({ theme }) => theme.colors.red};
    }
  }
`;

export const TrackingContainer = styled.ul`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem 0.5rem 1rem 0;
  margin-top: 0.5rem;
  border-radius: 0.25rem;
`;

export const TrackingItem = styled.li`
  width: 8rem;
  text-align: center;
  line-height: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 65px;
    display: block;
    height: 0.25rem;
    width: 39vw;
    background-color: ${({ theme }) => theme.colors.darkBlue};
  }

  &:first-child:after {
    width: 20vw;
    left: 3.75rem;
  }

  &:last-child:after {
    width: 20vw;
    right: 3.75rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    &:after {
      content: '';
      position: absolute;
      top: 65px;
      display: block;
      height: 0.25rem;
      width: 34rem;
      background-color: ${({ theme }) => theme.colors.darkBlue};
    }

    &:first-child:after {
      width: 30rem;
      left: 3.75rem;
    }

    &:last-child:after {
      width: 30rem;
      right: 3.75rem;
    }
  }
  &.checked {
    &:after {
      background-color: ${({ theme }) => theme.colors.blue5};
    }
  }

  &.loading {
    &:after {
      background-color: ${({ theme }) => theme.colors.gray7};
      background-image: linear-gradient(
        90deg,
        ${({ theme }) => theme.colors.gray7},
        ${({ theme }) => theme.colors.white2},
        ${({ theme }) => theme.colors.gray7}
      );
      animation: pulse-animation 1.2s ease-in-out infinite;

      @keyframes pulse-animation {
        0% {
          background-position: -200px 0;
        }
        100% {
          background-position: calc(200px + 100%) 0;
        }
      }
    }
  }

  & > h4 {
    font-size: 0.875rem;
    font-weight: 700;
    height: 2rem;
    width: 7rem;
    color: ${({ theme }) => theme.colors.darkBlue};
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  & > span.date {
    color: ${({ theme }) => theme.colors.grayDark};
    font-size: 0.75rem;
  }
`;

interface ITrackingCircleProps {
  checkedPercentage: number;
}

export const TrackingCircle = styled.div<ITrackingCircleProps>`
  height: 3.25rem;
  width: 3.25rem;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  z-index: 1;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  background-color: ${({ theme }) => theme.colors.darkBlue};

  & > div.checked {
    width: 100%;
    height: ${(props) => props.checkedPercentage}%;
    background-color: ${({ theme }) => theme.colors.blue5};
    position: absolute;
    bottom: 0;
    animation: checkedAnimationHeight 0.75s ease-out;

    @keyframes checkedAnimationHeight {
      from {
        height: 0%;
      }
    }
  }

  & > span.value {
    color: ${({ theme }) => theme.colors.white};
    font-weight: 700;
    font-size: 0.875rem;
    position: absolute;

    &.s {
      font-size: 0.75rem;
    }

    &.es {
      font-size: 0.675rem;
    }

    &.ees {
      font-size: 0.5rem;
    }
  }

  &.checked {
    border: 2px solid ${({ theme }) => theme.colors.blue5};
  }
`;

export const TrackingCircleLoading = styled.div`
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 1;
`;
